import { Type } from "@angular/core";
import { EntityBase, IEntityBaseInfo } from "@kiraah-shared/common";

export interface IDashBoardWidgetComponent {
  data: IDashboardWidgetDataInfo | undefined;
}

export class DashboardWidget {
  constructor(public component: Type<any>, public data: IDashboardWidgetDataInfo = <IDashboardWidgetDataInfo>{ Row: 0, Col: 0 }) { }

  static createInstance() {
    return new DashboardWidget(DashboardWidget);
  }
}

export interface IDashboardWidgetDataInfo extends IEntityBaseInfo {
  Label?: string;
  Row: number;
  Col: number;
  Properties?: { [key: string]: any; };
}

export class DashboardWidgetData extends EntityBase {
  Label?: string;
  Row: number;
  Col: number;
  Properties?: { [key: string]: any; };

  constructor(info: IDashboardWidgetDataInfo) {
    super(info);

    this.Label = info.Label;
    this.Row = info.Row;
    this.Col = info.Col;
    this.Properties = info.Properties;
  }
}

export interface IDashboardRenderInfo {
  Rows: IDashboardRow[];
  widgets: DashboardWidget[];
}

export interface IDashboardRow {
  Index: number;
  Cols: IDashboardCol[];
}

export interface IDashboardCol {
  Index: number;
  Size: number;
  Widget: DashboardWidget;
}

export class DashboardRender {
  Rows: IDashboardRow[];

  /**
   * Creates a new instance of DashboardRender.
   */
  private constructor(info: IDashboardRenderInfo) {
    this.Rows = info?.Rows ? info.Rows : this.defaultRender();
  }

  static build(config: string[], widgets: DashboardWidget[]): DashboardRender {
    let rows: IDashboardRow[] = [];

    if (!config || config.length == 0) {
      throw 'Invalid dashboard config';
    }

    config.map(entry => {
      if (!entry) {
        throw `Invalid dashboard row config ${entry}`;
      }

      let splitted = entry.split('-').map(e => +e);

      let totalSize = 0;
      splitted.map(e => totalSize += e);
      if (totalSize != 12) {
        throw `Invalid dashboard row config ${entry}`;
      }

      let row = <IDashboardRow>{ Cols: [], Index: rows.length };
      let colIndex = 0;
      splitted.map(size => {
        let widget = widgets.find(w => w.data.Row == row.Index && w.data.Col == colIndex);

        row.Cols.push(<IDashboardCol>{ Size: size, Index: colIndex, Widget: widget });
        colIndex++;
      });
      rows.push(row);
    });

    return new DashboardRender(<IDashboardRenderInfo>{ Rows: rows, });
  }

  private defaultRender(): IDashboardRow[] {
    return [
      <IDashboardRow>{
        Cols: [<IDashboardCol>{ Size: 12, Index: 1 }]
      }
    ]
  }
}

export class IEChartDataItem {
  name?: string;
  value?: number;
  itemStyle?: IEChartDataItemStyle;
}

export class IEChartDataItemStyle {
  color?: string;
}
